<template>
    <router-view :key="route.path" />

    <NotificationsView />
    <ModalRootView />
</template>

<script lang="ts" setup>
    import { useRoute } from 'vue-router';
    import NotificationsView from '@/components/modals/NotificationsView/NotificationsView.vue';

    const route = useRoute();

    defineOptions({
        name: 'App',
    });
</script>
